import './dropDownComponent.css';
import { useEffect, useState } from 'react';

function DropDownComponent({data, itemChoisir, setItemChoisir, filter, inactive}) {
    const [open, setOpen] = useState(false);
    const [ulHeight, setUlHeight] = useState(0);
    const [inputValue, setInputValue] = useState("");

    const openHandler = (e) => {
        setOpen(prev => {
            if (open) {
                setUlHeight(0);
            } else {
                setUlHeight(e.target.nextElementSibling.scrollHeight);
            }
            return !prev;
        })
    }
    const itemChoisirHandle =(item)=>{
        setItemChoisir({nom: item.nom, id: item.id})
        setOpen(prev=>!prev);
        setInputValue('');
    }
    const inputValueHandler=(e)=>{
        setInputValue(e.target.value);
    }


    return (
        <div className={[open ? "dropdown active" : "dropdown", inactive ? 'inactive' : ''].join(' ')} style={ filter ? { marginRight: '20px', } : { marginRight: 0 }}  >
            <div className="select-btn" onClick={(e) => openHandler(e)}>
                {
                    itemChoisir && (
                        <span style={itemChoisir.id === 0 ? {color : '#777777'} : {color : 'inherit'}}> {itemChoisir.nom }</span>
                    ) 
                }
                <i className='bx bx-chevron-down' ></i>
            </div>
            <div className="content" style={open ? { height: ulHeight } : { height: 0 }}>
                <div style={{ padding: "10px 10px" }}>
                    <div className="search">
                        <i className='bx bx-search-alt-2'></i>
                        <input type="text" placeholder="Search" onChange={e=>inputValueHandler(e)} />
                    </div>
                    <div className="options">
                        {
                            itemChoisir && (
                                data.map((item, index) => {
                                    if(item.nom.toLowerCase().includes(inputValue.toLocaleLowerCase())){
                                        return <li key={index} onClick={()=>itemChoisirHandle(item)} className={itemChoisir.id === item.id ? "selected" : ""}>{item.nom}</li>
                                    }
                                    
                                })
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
export default DropDownComponent